import script from "./UserQuickPeek.vue?vue&type=script&setup=true&lang=js"
export * from "./UserQuickPeek.vue?vue&type=script&setup=true&lang=js"

import "./UserQuickPeek.vue?vue&type=style&index=0&id=2b65c25a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b65c25a"]])

export default __exports__